<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <add-coupon-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></add-coupon-form>
  </j-modal>
</template>

<script>

  import AddCouponForm from "./AddCouponForm";
  export default {
    name: 'AddCouponModal',
    components: {
      AddCouponForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(data){
        this.$emit('ok',data);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>